import { createAsyncThunk } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

import cloneDeep from 'lodash/cloneDeep';
import concat from 'lodash/concat';
import get from 'lodash/get';
import remove from 'lodash/remove';

import { showLoading, hideLoading } from '../app';
import WebAPIClient, { errorResponseToastr } from '../../api';
import { getAlarms } from '../alarms';
import { getInverters } from '../inverters';
import { getLicenses } from '../licenses';
import { getLoggers } from '../loggers';
import { getMemberships } from '../memberships';
import { getMeters } from '../meters';
import { updateNodes } from '../nodes';
import { setLoader, setWebsocketLastUpdate } from '../pages';
import { getReportsData } from '../reports';
import { getSensors } from '../sensors';
import { getSites } from '../sites';
import { toastr } from '../../components/CustomToast';

const getOrganizations = createAsyncThunk(
  'organization/getOrganizations',
  async (user, { dispatch, getState, requestId }) => {
    try {
      const { loading, currentRequestId } = getState().organizations;

      if (!user) {
        const { item: data } = getState().user;
        user = { ...data };
      }

      if (loading !== true || requestId !== currentRequestId) {
        return;
      }

      dispatch(getSites());
      dispatch(getLoggers());
      dispatch(getMeters());
      dispatch(getInverters());
      dispatch(getSensors());
      dispatch(getMemberships());
      dispatch(getReportsData(user));
      dispatch(getLicenses());
      dispatch(getAlarms());

      const organizations = await new WebAPIClient().GET(
        '/resource/organizations'
      );
      const portfolioMemberships = await new WebAPIClient().GET(
        '/resource/portfolio_memberships'
      );
      dispatch(setWebsocketLastUpdate(dayjs()));
      return {
        data: organizations,
        portfolioMemberships,
      };
    } catch (err) {
      errorResponseToastr(err);
    } finally {
      dispatch(setLoader(false));
    }
  }
);

const putOrganization = createAsyncThunk(
  'organization/putOrganization',
  async (item, { dispatch, getState, requestId }) => {
    try {
      const {
        data: organizations,
        currentRequestId,
        loading,
      } = getState().organizations;

      if (loading !== true || requestId !== currentRequestId) {
        return;
      }

      dispatch(showLoading());
      const updatedOrg = await new WebAPIClient().PUT(
        `/resource/organizations/${item.org_id}`,
        item
      );

      let _organizations = cloneDeep(organizations);
      remove(_organizations, { org_id: get(updatedOrg, 'org_id') });

      _organizations = concat(_organizations, updatedOrg);
      dispatch(updateNodes({ organizations: _organizations }));

      toastr.success({ title: 'Organization updated' });
      return { data: _organizations };
    } catch (err) {
      errorResponseToastr(err);
    } finally {
      dispatch(hideLoading());
    }
  }
);

export { getOrganizations, putOrganization };
